import React, { memo, useState } from 'react';
import { Input, Button } from 'antd';

import { useDebounce } from '@components';

import Modal from './whiteListAddModal';

export const SearchInput = ({ onChange }) => {
  const handleChange = useDebounce(onChange, 500);
  return (
    <Input
      onChange={(e) => handleChange({ text: e.target.value })}
      className="white-list-search-input"
      size="large"
      placeholder="Search"
      prefix={<span className="appkiticon icon-search-outline" />}
    />
  );
};

const AddButton = () => {
  const [isModalVisible, toggleModalVisible] = useState(false);

  const closeModal = () => {
    toggleModalVisible(false);
  };
  return (
    <>
      <Modal
        isVisible={isModalVisible}
        onCancel={() => toggleModalVisible(false)}
        onOk={closeModal}
      />

      <Button
        className="add-btn"
        type="primary"
        onClick={() => toggleModalVisible(true)}
      >
        <span className="appkiticon icon-circle-plus-fill a-font-16" />
        ADD USER
      </Button>
    </>
  );
};

function ToolBar({ onFilter }) {
  return (
    <div className="topbar-wrapper">
      <SearchInput onChange={onFilter} />
      <AddButton />
    </div>
  );
}

export default memo(ToolBar);
